import { useCallback } from 'react'
import { loadQuestionnaireWithValueSets } from 'app/api/forms/services/questionnaireService'
import { prefetchValueSets } from 'app/api/forms/services/valueSetService'
import { QuestionnaireParser } from 'app/api/forms/services/questionnaireParser'
import { ValueSetConcept } from 'app/api/forms/types/fhir'

/**
 * React hook for questionnaire loading and value-set prefetching.
 * Wraps `loadQuestionnaireWithValueSets` from questionnaireService,
 * `prefetchValueSets` from valueSetService, and re-exports `QuestionnaireParser`
 * so components import from hooks instead of directly from service/parser paths.
 */
export const useQuestionnaireService = () => {
    const loadQuestionnaire = useCallback(
        (
            formTypeOrId: string,
            userId: string
        ): Promise<QuestionnaireParser | null> => {
            return loadQuestionnaireWithValueSets(formTypeOrId, userId)
        },
        []
    )

    const prefetch = useCallback(
        (
            valueSetUrls: string[],
            userId: string
        ): Promise<Map<string, ValueSetConcept[]>> => {
            return prefetchValueSets(valueSetUrls, userId)
        },
        []
    )

    return {
        loadQuestionnaireWithValueSets: loadQuestionnaire,
        prefetchValueSets: prefetch,
    }
}

// Re-export QuestionnaireParser so components can import the class from hooks
export { QuestionnaireParser } from 'app/api/forms/services/questionnaireParser'
